module.exports = __webpack_public_path__ + "img/icon-certificate-white.18db281e.svg";